import { useState } from 'react';
import { FilterChips } from '@/components/portal/filter-chips';
import { RequestListCard } from '@/features/requests/request-list-card';
import { useRequestSummary } from '@/hooks/use-requests';

/**
 * « Mes demandes » (navigation entry). Not drawn in the mock-ups: same card as
 * screen 01, plus the requests of the team when the API allows it (team
 * option for a Demandeur, always for a Référent) — see CLAUDE.md.
 */
export function RequestsPage() {
  const summary = useRequestSummary();
  const [scope, setScope] = useState<'mine' | 'team'>('mine');
  const canSeeTeam = summary.data?.team != null;
  return (
    <>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <h1 className="m-0 text-[26px] font-black tracking-[-0.01em]">Mes demandes</h1>
        {canSeeTeam && (
          <FilterChips
            ariaLabel="Demandes affichées"
            value={scope}
            onChange={setScope}
            options={[
              { value: 'mine', label: 'Mes demandes' },
              { value: 'team', label: 'Demandes de mon équipe' },
            ]}
          />
        )}
      </div>
      <RequestListCard key={scope} title={scope === 'mine' ? 'Mes demandes' : 'Demandes de mon équipe'} scope={scope} />
    </>
  );
}
